import { jsx, jsxs } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import Badge from '../Badge/Badge.js';
import SuccessoIcon from '../Icons/SuccessoIcon.js';
import ErroreIcon from '../Icons/ErroreIcon.js';
import State from './State.js';

const renderIcon = (icon, index, state) => {
    if (icon) {
        return icon;
    }
    if (state === State.DONE) {
        return jsx(SuccessoIcon, {});
    }
    if (state === State.ERROR) {
        return jsx(ErroreIcon, {});
    }
    if (state === State.ACTIVE) {
        return jsx(Badge, { info: true, children: index });
    }
    return jsx(Badge, { children: index });
};
function StepItem({ className = '', index = 0, optional = false, state, onClick, title, icon, subTitle, }) {
    const stepClasses = cns('stepper__step', {
        'stepper__step--active': state === State.ACTIVE,
        'stepper__step--todo': state === State.TODO,
        'stepper__step--done': state === State.DONE,
        'stepper__step--error': state === State.ERROR,
    }, className);
    const intestazioneClasses = cns('stepper__stepIntestazione', {
        'stepper__stepIntestazione--selectable': !!onClick,
    }, className);
    return (jsx("div", { className: stepClasses, children: jsxs("div", { className: intestazioneClasses, onClick: () => { onClick === null || onClick === void 0 ? void 0 : onClick(index); }, role: "presentation", children: [renderIcon(icon, index, state), jsxs("div", { className: "stepper__step__infoes", children: [jsx("span", { className: "stepper__stepName", children: title }), subTitle && jsx("span", { className: "stepper__step--sottoTitolo", children: subTitle }), optional && jsx("span", { className: "stepper__step--facoltativo", children: "Opzionale" }), state === State.ERROR && jsx("span", { className: "stepper__step--errore", children: "Errore" })] })] }) }, index));
}

export { StepItem as default };
